import { TaskSvg } from '../svg/task.svg';
import { IconPropsDeprecated } from '@umanforge/common';

export const TaskIcon = ( { className = 'w-5 h-5 text-blue-600', size, onClick }: IconPropsDeprecated ) => {
  return (
    <TaskSvg
      className={ className }
      size={ size }
      onClick={ onClick }
    />
  );
};
